import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemStringEditor from '../FormItemStringEditor';
import FormItemStringEditorForDataGrid from '../FormItemStringEditorForDataGrid';
import FormItemStringRender from '../renders/FormItemStringRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';
import StringUtil from '../../utils/StringUtil';
import GOTUtil from '../../utils/GOTUtil';
import GOT from '../../utils/GOT';
import CmdTypeActions from '../../actions/CmdTypeActions';
import FormResourceUtil from '../../utils/FormResourceUtil';
import MainFormFactory from '../../utils/MainFormFactory';
import {UpdateDropDownContentStore} from '../../stores/CmdTypeStore';
import ControlPropertyConst from '../controlproperty/ControlPropertyConst';

export default class FormItemStringEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemStringEditorControl";
		this.serverHasLookup = null;
		this.module = module;
		if(!forLookup)this.initMainFormContextMenuData();
		this.unsubscribeUpdateDropDownContenStore = UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
		var extendsPro = this.xml.Properties.Extends;
		if(extendsPro)
		{
			if(extendsPro.refentityid && extendsPro.refinnerid)
			{
				var table = GOT.getTable(extendsPro.refentityid);
				if(table)
				{
					var tableField = GOT.getTableField(table,extendsPro.refinnerid);
					if(tableField && tableField.type == "Component")
					{
						var extendsValue = extendsPro.Value;
						if(extendsValue)
						{
							var arr = extendsValue.split(".");
							this.componentField = arr.pop();
							this.componentDim = arr.join(".");
							
						}
					}

				}
				
			}
		}
	}
	//插件内部节点带点号
	doFieldModifiedRemote(dataField,newValue,oldValue,record,comoponent,extralParms = {})
	{
		if(this.group)
		{
			
			let arr = dataField.split(".");
			let aliasName = arr.shift();
			let fieldName;
			if(this.componentField)
			{
				fieldName = this.componentDim;
			}
			else
			{
				fieldName = arr.join(".");
			}
			let componentName = null;
			if(this.componentField)
				componentName = this.componentField;
			extralParms.editorName = this.xml.name;
			extralParms.formDataSourceField = this.formDataSourceField;
			return this.group.doFieldModifiedRemote(aliasName,fieldName,componentName,oldValue,newValue,dataField,record,comoponent,extralParms);	
			
		}
		return true;
	}

	onUpdateDropDownContnent(type,control,formModuleInstanceuuId)
	{
		if(this.module.instanceUUId == formModuleInstanceuuId && control == this.xml.name)
		{
			if(type == "numKeyBoard")
			{
				this.dropDownNumKeyBoard=true;
			}
			else if(type == "normal")
			{
				this.dropDownNumKeyBoard=false;
			}
		}
	}

	initMainFormContextMenuData()
	{
		/*TODO用户设置if(ClientSession.getClientSessionInstance().canEnterMainform==false)
			return;*/
		// if(this.isDataMethodField == true)
		// 	return;
		let contextMenuItems = this.contextMenuData.items;
		let contextMenuItem = {label:"进入主表[Ctrl+M]",icon:'',isEnterMainForm:true,visible:false,action:this.enterMainForm.bind(this)};
		contextMenuItems.push(contextMenuItem);
		
		/*if(this.serverUpateMainForm != null)
		{
			contextMenuItem.visible = Boolean(FormItem_StringEditor(gongqiFormItem).serverUpateMainForm);
			hasMainForm = contextMenuItem.visible;
			return;
		}*/
		var methodName;
		
		if(this.group && this.getDataField())
		{
			//MainForm二次开发应为FormDataSourceField的名字 若包含.号 则改为下划线（针对于Component）
			var i = this.getDataField().indexOf(".");
			methodName = StringUtil.convertToEachFirstUpperCase(this.getDataField().substring(i+1));
			methodName = this.groupAlias + ".mainForm_" + methodName;
		}
		else
		{
			methodName = "mainForm_" + this.xml.name;
		}
		
		let mi = FormResourceUtil.getCommandArgMethodInfo(methodName,window.menuItemId,window.formId);
		if(mi)
		{
			contextMenuItem.visible = true;
			this.hasMainForm = true;
		}
		else
		{
			let hasGotMainForm = MainFormFactory.hasMainForm(this.formId,this.xml.id,GOTUtil.getComponentItemName(this.getDataField()));
			if(hasGotMainForm)
			{
				contextMenuItem.visible = true;
				this.hasMainForm = true;
			}
		}
	}

	enterMainForm()
	{	
		if(!this.hasMainForm)
			return;
		let e = arguments[0];
		let value = "";
		if(e.hasOwnProperty("currentValue"))
		{
			value = e.currentValue;
		}
		else if(!e.currentTarget)
			return;

		if(!e.hasOwnProperty("currentValue"))
		{
			if($(e.currentTarget).hasClass("editorGroup"))
			{
				value =  $(e.currentTarget).find(".input-group>input").val();
			}
			else if($(e.currentTarget).hasClass("gongqi_render_select"))
			{
				value = $(e.currentTarget).text();
			}
			else
			{
				value = $(e.currentTarget).val();
			}
		}
		
		//let value = $("#input"+this.xml.id).val() || $("#stringRender"+this.xml.id).text();
		//let menuItem = GOT.getMenuItem(this.menuItemId);
		let options = {
			entityId:this.formId,innerId:this.xml.id,componentItemName:GOTUtil.getComponentItemName(this.getDataField()),
			value:value,record:this.group?this.group.currentRecord:null,fm:this.module,dataField:this.getDataField(),editorName:this.xml.name,
			groupAlias:this.groupAlias?this.groupAlias:null,paramString:null
		};
		let extendsPro = GOTUtil.getProperty(this.xml,"Extends");
		if(extendsPro && extendsPro.refentityid)
		{
			let table = GOT.getTable(extendsPro.refentityid);
			if(table)
			{
				let tableField = GOT.getTableField(table,extendsPro.refinnerid);
				let filterFieldPro = GOTUtil.getProperty(tableField,"FilterField");
				let filterField = filterFieldPro.V;
				if(options.record && options.groupAlias)
				{
					let filterDataField = options.groupAlias + "." + StringUtil.convertToFirstLowerCase(filterField);
					let filterValue = options.record[filterDataField];
					options.filterValue = filterValue;
				}
			}
		}
		
		MainFormFactory.callMainForm(options);

		//LogHelper.setUserOprLog("进入主表",this.entityId,this.gongqiFormItem?this.gongqiFormItem.dataSource_Alias:"",this.gongqiFormItem?String(this.gongqiFormItem.xml.@name):"");
		
		//dispatchEvent(formModuleEvent);
	}

	getQueryFilteredVaue(value)
	{
		if(value == "" || value == null)
			return "''";
		if(value == "*")
			return value;
		var filter = this.getProperty_QueryFilter();
		if(filter == "")
			filter = "Contains";
		
		if(filter == "Contains")
		{
			return "*" + value + "*";
		}
		else if(filter == "NotContains")
		{
			return "!(*" + value + "*)";
		}
		else if(filter == "StartWith")
		{
			return value + "*";
		}
		else if(filter == "NotStartWith")
		{
			return "!(" + value + "*)";
		}
		else if(filter == "EndWith")
		{
			return "*" + value;
		}
		else if(filter == "NotEndWith")
		{
			return "!(*" + value + ")";
		}
		
		
		return filter=="="?value:(filter+value);
	}
		

	getComponentInstance(parent,forLookup)
	{
		let displayLengthWidth = this.getDisplayLengthWidth();
		let displayHeight=this.getProperty_DisplayHeight();
		let displayLength=this.propertyDisplayLength?this.propertyDisplayLength:this.getProperty_DisplayLength();
		let layout = parent.Properties.Layout.Value;
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let commonProps = this.getCommonProps();
		let notNull=this.propertyNotNull?this.propertyNotNull:this.getProperty_NotNull();
		let _customStyle = this.getStyle();
		let _initRecord = this.record;
		if(!_initRecord)
	    {
		  	if(!this.group)
		  	{
		  		let defaultValue = this.getDefaultValue();
		  		_initRecord = defaultValue;
		  	}
		}
		let displayStyle = this.getProperty_DisplayStyle();
	  	this.component = <FormItemStringEditor key={this.xml.id} xml={this.xml} queryOnTextChanging = {this.getProperty_SearchMode() == "OnTyping"} 
                parentLayout={layout} forLookup={forLookup} formType={EditorFormType.FormModule} allowKeyIn = {this.getProperty_AllowKeyIn()}
                displayHeight={displayHeight} displayLength={displayLength} notNull={notNull} moduleInstanceId={this.module.instanceUUId}
                displayLengthWidth={displayLengthWidth} groupAlias={this.groupAlias} group={this.group} initEditorValue={this.initEditorValue}
                dataField = {this.getDataField()} initRecord = {_initRecord} filterField = {this.getProperty_FilterField()} filterEditor = {this.getProperty_FilterEditor()}
                label={label} customStyle={_customStyle} formId={this.formId} menuItemId={this.menuItemId}
                contextMenuData={this.contextMenuData} trim={this.getProperty_Trim()} changeCase={this.getProperty_ChangeCase()} stringSize={this.getProperty_StringSize()}
				regular={this.getProperty_Regular()} assignedFormLookup={this.getProperty_FormLookup()} dropDownMode={this.getProperty_DropDownMode()}
				control = {this} serverSpecify={this.getServerSpecify()} underQueryGroup={this.isUnderQueryGroup()} 
				verticalAlign={this.getProperty_VAlignment()} returnLookup = {this.getProperty_ReturnLookup()} {...commonProps}
				cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle}/>;
		return this.component;
	}

	getProperty_ReturnLookup()
	{
		return this.properties.ReturnLookup;
	}

	getProperty_DropDownMode()
	{
		let proName = this.properties.hasOwnProperty("LookupMode")?"LookupMode":"DropDownMode";
		if(this.properties[proName] == "PullDown")
			return "drop";
		else
			return "pop";
	}

	getProperty_DropDownContent()
	{
		return this.properties.DropDownContent;
	}

	getProperty_FormLookup()
	{
		return this.properties.FormLookup;
	}

	getProperty_Trim()
	{
		return this.properties.Trim;
	}

	getProperty_ChangeCase()
	{
		return this.properties.ChangeCase;
	}

	getProperty_StringSize()
	{
		return this.properties.StringSize;
	}

	getProperty_Regular()
	{
		return this.properties.Regular;
	}

	getProperty_SearchMode()
	{
		return this.properties.SearchMode;
	}

	getProperty_AllowKeyIn()
	{
		if(!this.properties.hasOwnProperty("AllowKeyIn"))
			return true;
		return this.properties.AllowKeyIn;
	}

	getProperty_FilterField()
	{
		let filterField = this.properties.FilterField;
		if(!filterField)
		{
			let extendsPro = GOTUtil.getProperty(this.xml,"Extends");
			if(extendsPro && extendsPro.refentityid)
			{
				let table = GOT.getTable(extendsPro.refentityid);
				if(table)
				{
					let tableField = GOT.getTableField(table,extendsPro.refinnerid);
					let filterFieldPro = GOTUtil.getProperty(tableField,"FilterField");
					filterField = filterFieldPro.V;
					if(!filterField){
						if(tableField.type=="Component"){
							let compoentItems = GOT.getTableFieldComponentItems(tableField);
							for(let i in compoentItems){
								let item = compoentItems[i];
								if(item.name == this.componentField){
									let RefDataType = GOTUtil.getProperty(item,"RefDataType");
									var compDataType = GOT.getDataType(RefDataType.refentityid);
									if(compDataType.DataTypeRelation){
										filterField = compDataType.DataTypeRelation.Properties.FilterField.V
										break;
									}
								}
							}
						}else{
							let extendsPro = GOTUtil.getProperty(tableField,"Extends");
							var compDataType = GOT.getDataType(extendsPro.refentityid);
							if(compDataType.DataTypeRelation){
								filterField = compDataType.DataTypeRelation.Properties.FilterField.V
							}
						}
					}
				}
			}
		}

		return filterField;
	}

	getProperty_FilterEditor()
	{
		let xml = this.xml;
		let filterEditorPro = GOTUtil.getProperty(xml,"FilterEditor");
		if(filterEditorPro && !filterEditorPro.V && !filterEditorPro.Value)
		{
			if(this.parentControl.classAlias == "FormItemFieldGroupControl")
			{
				return this.parentControl.getProperty_FilterEditor();
			}
		}
		return filterEditorPro;
		//return this.properties.FilterEditor;
	}

	getProperty_Alignment()
	{
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.HorizontalAlignment)
			return displayStyle.HorizontalAlignment;
		if(this.properties.hasOwnProperty("Alignment"))
			return this.properties.Alignment;
		return "Left";
	}

	getDisplayAsPassword()
	{
		//TODO 获取二次开发属性 var key = window.formId+this.xml.id//+ControlPropertyConst.DISPLAYASPASSWORD;
		//var _displayAsPassword:* = formDesign.formModule.getControlProperties(key);
		//if(_displayAsPassword == null)
		//{
			var dataMethod = this.getProperty_DataMethod();
			if(!this.group && dataMethod == "Password")
				return true;
			if(this.xml.name && typeof(this.xml.name) == "string" && 
				(this.xml.name.indexOf("Password")!=-1 || this.xml.name.indexOf("password")!=-1)
			)
				return true;
			return false;
		//}
		//return _displayAsPassword;
	}

	isDataAnlysFilter()
	{
		if(window.isDataSetView == true)return false;
		return !MainFormFactory.hasMainForm(this.formId,this.xml.id,GOTUtil.getComponentItemName(this.getDataField()));
	}


	getServerSpecify()
	{
		var methodName;var _dataField = this.getDataField();
		if(this.group && _dataField && _dataField!="")
		{
			//TODO 以前就有错误? Component中的点号并未改成_ 二次开发应为FormDataSourceField的名字 若包含.号 则改为下划线（针对于Component）
			var i = _dataField.indexOf(".");
			methodName = StringUtil.convertToEachFirstUpperCase(_dataField.substring(i+1));
			methodName = this.group.groupAlias + ".openLookup_" + methodName;
		}
		else
		{
			methodName = "openLookup_" + this.xml.name;
		}
		
		var mi = FormResourceUtil.getCommandArgMethodInfo(methodName,window.menuItemId,window.formId);
		return mi;
	}


	isMainGroup()
	{
		//该函数只在主画面被调用 下拉框上不调用 所以直接采用window.formXML
		var firstDataSource = window.formXML.FormDataSources.DataSources[0];
		if(!firstDataSource)
			return false;
		var mainDataSource = this.module.formDataSources.sources[firstDataSource.name];
		return mainDataSource?(mainDataSource.group == this.group):false;
	}
	
	getRefEntityId()
	{
		var extendsPro = GOTUtil.getProperty(this.xml,"Extends");
		return extendsPro.refentityid; 
	}

	_inputCacheKey = null;
	_inputCacheKeyInited = false;
	getInputCacheKey()
	{
		if(this._inputCacheKeyInited)
			return this._inputCacheKey;
		var extendsXML = this.xml.Properties.Extends;
		if(extendsXML.hasOwnProperty("refinnerid"))
		{
			var extendsValue = extendsXML.Value;
			var dotIndex = extendsValue.indexOf(".");
			if(dotIndex != -1)
			{
				var componentName = extendsValue.substr(dotIndex+1);
			}

			var tableId = extendsXML.refentityid;
			var tableFieldId = extendsXML.refinnerid;
			var table = GOT.getTable(tableId);
			var tableField = GOT.getTableField(table,tableFieldId);
			var extendsPro = GOTUtil.getProperty(tableField,"Extends");
			if(extendsPro.hasOwnProperty("refentityid"))
			{
				if(!componentName)
				{
					this._inputCacheKey = extendsPro.refentityid;
				}
				else
				{
					var dataType = GOT.getDataType(extendsPro.refentityid);
					if(!dataType)
						throw new Error("InputCacheKey 从FormItem起始未能找到一个DataType");
					var arrayItemList = dataType.DataTypeArrayItems;
					if(Array.isArray(arrayItemList))
					{
						for(let i = 0;i<arrayItemList.length;i++)
						{
							let arrayItem = arrayItemList[i];
							var refProValue = GOTUtil.getPropertyValue(arrayItem,"RefDataType");
							if(refProValue == componentName)
							{
								var refPro = GOTUtil.getProperty(arrayItem,"RefDataType");
								_inputCacheKey = refPro.refentityid;
							}
						}	
					}
				}
			}
		}
		else if(extendsXML.hasOwnProperty("refentityid"))
		{
			this._inputCacheKey = extendsXML.refentityid;
		}
		
		this._inputCacheKeyInited = true;
		return this._inputCacheKey;
	}

	setControlProperty(property,value)
	{
		let result = super.setControlProperty(property,value);
		if(!result)
		{
			if(property == ControlPropertyConst.IMEENABLE)
			{
				this.propertyImeEnabel = value;
				this.propertyImeEnabelSetted = true;
				CmdTypeActions.updateControlProperty(this.xml.name,property,value,this.module.intanceUUId);
				return true;
			}
		}
		return false;
	}
	
	getRefInnerId()
	{
		var extendsPro = GOTUtil.getProperty(this.xml,"Extends");
		return extendsPro.refinnerid; 
	}


	getComponentInstanceForDataGrid(parent,forLookup)
	{
		let _parentXML = this.parentXML;
		let _displayHeight=this.getProperty_DisplayHeight();
		let _gridXML = this.parentXML.type == "DataGrid"?this.parentXML:this.parentControl.parentControl.xml;
		return <FormItemStringEditorForDataGrid xml={this.xml} forLookup={forLookup} trim={this.getProperty_Trim()} changeCase={this.getProperty_ChangeCase()} stringSize={this.getProperty_StringSize()}
				displayHeight={_displayHeight} regular={this.getProperty_Regular()} formId={this.formId} menuItemId={this.menuItemId} dataField = {this.getDataField()} dropDownMode={this.getProperty_DropDownMode()}
				assignedFormLookup={this.getProperty_FormLookup()} group={this.group} formType={EditorFormType.FormModule} moduleInstanceId={this.module.instanceUUId}
				queryOnTextChanging = {this.getProperty_SearchMode() == "OnTyping"} filterField = {this.getProperty_FilterField()}
				control = {this} groupAlias={this.groupAlias} serverSpecify={this.getServerSpecify()} allowKeyIn={this.getProperty_AllowKeyIn()}
				colXml={this.xml} gridXml={_gridXML} contextMenuData={this.contextMenuData}
				returnLookup = {this.getProperty_ReturnLookup()} verticalAlign={this.getProperty_VAlignment()} trim={this.getProperty_Trim()}
				/>;
	}

	getRenderForDataGrid(forLookup)
	{
		let _parentXML = this.parentXML;
		let _gridXML = this.parentXML.type == "DataGrid"?this.parentXML:this.parentControl.parentControl.xml;
		let isMutiRow = false;
		let _displayHeight=this.getProperty_DisplayHeight();
		if(_displayHeight>1)
		{
			isMutiRow = true;
		}
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemStringRender contextMenuData={this.contextMenuData} group={this.group} dataField = {this.getDataField()} forLookup={forLookup}
				formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={_gridXML} textAlign={this.getProperty_Alignment()}
				isMutiRow={isMutiRow} moduleInstanceId={this.module.instanceUUId} verticalAlign={this.getProperty_VAlignment()}
				cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle} trim={this.getProperty_Trim()}/>;
	}

	getRenderForDynamicColumn(dataField)
	{
		let _parentXML = this.parentXML;
		let _gridXML = this.parentXML.type == "DataGrid"?this.parentXML:this.parentControl.parentControl.xml;
		let isMutiRow = false;
		let _displayHeight=this.getProperty_DisplayHeight();
		if(_displayHeight>1)
		{
			isMutiRow = true;
		}
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemStringRender contextMenuData={this.contextMenuData} group={this.group} dataField = {dataField} forLookup={false}
				formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={_gridXML} textAlign={this.getProperty_Alignment()}
				isMutiRow={isMutiRow} moduleInstanceId={this.module.instanceUUId} verticalAlign={this.getProperty_VAlignment()}
				cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle}/>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemStringEditorControl.js